import PromotionsCounter from 'src/common/PromotionsCounter/PromotionsCounter';
import StoreCounter from 'src/common/StoreCounter/StoreCounter';

// Matched against the nav/menu item `link` (its CMS `location`). `/account/store`
// is the Smartico Store route (`staticRoutes.smarticoStore`); kept as a literal so
// this module stays free of the @atlas/routing import chain.
export const MENU_ITEMS_WITH_COUNTER = ['/promotions', '/account/store'];

export const MENU_ITEM_COUNTER_COMPONENT = {
  '/promotions': PromotionsCounter,
  '/account/store': StoreCounter,
};
